module.exports = __webpack_public_path__ + "img/3djake_niceabs_natural.7b1a5ced.jpg";